module.exports = __webpack_public_path__ + "img/beneficio3.7bb5e12a.svg";